import Backdrop from '../backdrop';
import Video from '../video';

export default class Modal {
    constructor(el) {
        this.modal = el;
        this.openers = document.querySelectorAll(`[data-modal-open="#${this.modal.id}"]`);
        this.closers = document.querySelectorAll(`[data-modal-close="#${this.modal.id}"]`);

        this.backdrop = new Backdrop();

        this.openers.forEach((item) => {
            item.addEventListener('click', (e) => this.open(e, item));
        });
        this.closers.forEach((item) => {
            item.addEventListener('click', (e) => this.close(e));
        });

        this.closeOutsideHandler = this.closeOutside.bind(this);
    }

    open(e) {
        e.stopPropagation();

        this.modal.classList.add('open');
        this.backdrop.create();

        this.backdropElement = document.querySelector('.backdrop');
        this.backdropElement.addEventListener('click', (e) => this.close(e));

        const videoElement = this.modal.querySelector('[data-modal-video]');
        if (videoElement) {
            new Video(videoElement);
        }
    }

    close(e) {
        e.stopPropagation();
        this.modal.classList.remove('open');
        this.modal.classList.add('close');

        setTimeout(() => {
            this.backdrop.destroy();
            this.modal.classList.remove('close');
        }, 300);

        document.removeEventListener('click', this.closeOutsideHandler);
    }

    closeOutside(e) {
        if (!e.target.closest(`#${this.modal.id}`)) {
            this.close(e);
        }
    }
}
